import { render } from "./PictureAvatarUser.vue?vue&type=template&id=d3395dce"
import script from "./PictureAvatarUser.vue?vue&type=script&lang=js"
export * from "./PictureAvatarUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__